import { MoneyFormatter } from '@/helpers/Formatting/MoneyFormatter';

const moneyFormatter = new MoneyFormatter();

export default function formatInvoiceAmount(amount, currency) {
  if (amount == null || amount === '') {
    return '';
  }

  const formatted = moneyFormatter.format(amount, currency, false);
  return formatted == null || formatted === '' ? String(amount) : String(formatted);
}
